const imgTeamPackageGoodsMain = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const imgDingGoods1 = "./assets/figma/ff32f555-12af-46a7-aa36-b66f07304d1d.png";
const imgEllipse37 = "./assets/figma/913dc448-4698-43da-9d8b-57b058da291a.svg";
const imgLine21 = "./assets/figma/855ab069-959b-4910-953b-d071eec60edc.svg";
const imgEllipse30 = "./assets/figma/6a078e48-5d9e-42ce-b364-3662c53ec13f.svg";
const imgArrow5 = "./assets/figma/86fee700-6c89-4ef3-a41a-21b7518ecb91.svg";
const img1 = "./assets/figma/29644144-a224-46c7-afb0-47d302ee0c45.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";

export default function TeamPackageGoodsMain() {
  return (
    <div className="s0 s1" data-node-id="856:2376" data-name="TEAM_PACKAGE/GOODS_MAIN">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <img alt="" className="s2 s9 s105 s258 s1" src={imgTeamPackageGoodsMain} />
      </div>
      <div className="s2 s460 s461 s462 s463" data-node-id="886:4" data-name="DINGAI_GOODS 1" />
      <div className="s2 s267 s268 s269 s270" data-node-id="856:2382" data-name="image 14" />
      <div className="s259 s2 s16 s141 s17 s24 s230 s26 s303 s277 s304" data-node-id="856:2390" data-name="TAB_TEAM">
        <a className="s16 s17 s305 s18 s306 s307 s464 s309 s0 s145 s146 s28 s34" data-node-id="856:2391" data-name="TAB_TEAM_GRAPHIC1">
          <div aria-hidden className="s2 s147 s3 s4 s145" />
          <p className="s23 s31 s32 s27 s0 s28 s29 s281 s149 s54" data-node-id="856:2392">
            GRAPHIC 1
          </p>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <a className="s16 s17 s305 s18 s306 s307 s308 s309 s0 s145 s146 s28 s34" data-node-id="856:2393" data-name="TAB_TEAM_GRAPHIC2">
          <div aria-hidden className="s2 s147 s3 s4 s145" />
          <p className="s23 s31 s310 s32 s27 s0 s28 s29 s281 s149 s119" data-node-id="856:2394">
            GRAPHIC 2
          </p>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <a className="s16 s17 s24 s305 s26 s42 s311 s307 s312 s309 s0 s145 s146 s28 s34" data-node-id="856:2395" data-name="TAB_TEAM_UI/UX">
          <div aria-hidden className="s2 s313 s3 s4 s145" />
          <div className="s16 s17 s18 s19 s0 s28 s318" data-node-id="856:2396">
            <p className="s23 s31 s310 s32 s27 s0 s28 s29 s281 s149 s319" data-node-id="856:2397">
              UI/UX
            </p>
          </div>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <button className="s16 s81 s17 s305 s18 s311 s307 s316 s309 s0 s145 s28 s34" data-node-id="856:2398" data-name="TAB_TEAM_PACKAGE">
          <div aria-hidden className="s2 s152 s3 s4 s145" />
          <div className="s16 s17 s18 s19 s0 s28 s318" data-node-id="856:2399">
            <p className="s23 s31 s310 s32 s27 s0 s28 s29 s281 s149 s319" data-node-id="856:2400">
              package
            </p>
            <div className="s0 s28 s320" data-node-id="856:2401">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgEllipse37} />
            </div>
          </div>
          <div className="s2 s3 s4 s150 s151" />
        </button>
        <a className="s16 s17 s305 s18 s306 s307 s317 s309 s0 s145 s146 s28 s34" data-node-id="856:2402" data-name="TAB_TEAM_MOTION">
          <div aria-hidden className="s2 s147 s3 s4 s145" />
          <p className="s23 s31 s32 s27 s0 s28 s29 s281 s149 s54" data-node-id="856:2403">
            MOTION
          </p>
          <div className="s2 s3 s4 s150 s151" />
        </a>
      </div>
      <div className="s259 s2 s16 s17 s24 s465 s18 s19 s466 s273 s274 s275 s276 s145 s146 s467 s278" data-node-id="856:2404">
        <div aria-hidden className="s2 s147 s3 s4 s145" />
        <div className="s16 s17 s24 s279 s26 s0 s28 s280" data-node-id="856:2405">
          <div className="s23 s31 s36 s27 s0 s28 s29 s281 s34 s38" data-node-id="856:2406">
            <p className="s468 s40">{`PACKAGE/GOODS `}</p>
            <p className="s468">AI RECIPE</p>
          </div>
          <div className="s46 s0 s28 s34" data-node-id="856:2407">
            <div className="s2 s48">
              <img alt="" className="s49 s9 s1" src={imgLine21} />
            </div>
          </div>
        </div>
        <div className="s16 s17 s24 s469 s26 s0 s28 s297" data-node-id="856:2412">
          <div className="s16 s17 s298 s18 s0 s28 s34" data-node-id="856:2413">
            <div className="s0 s28 s299" data-node-id="856:2414">
              <div className="s2 s300">
                <img alt="" className="s49 s9 s1" src={imgEllipse30} />
              </div>
            </div>
            <p className="s23 s301 s302 s32 s27 s0 s28 s29 s281 s54" data-node-id="856:2415">
              CHATGPT
            </p>
          </div>
        </div>
        <a className="s282 s16 s141 s17 s24 s283 s284 s18 s42 s285 s286 s287 s0 s145 s146 s28 s288 s289 s290" data-node-id="856:2408" data-name="ARCHIVE4">
          <div className="s16 s17 s18 s19 s0 s28 s34" data-node-id="856:2409">
            <p className="s23 s31 s32 s27 s0 s28 s29 s37 s149 s54" data-node-id="856:2410">
              ARCHIVE
            </p>
            <div className="s46 s0 s28 s291" data-node-id="856:2411">
              <div className="s2 s292">
                <img alt="" className="s49 s9 s1" src={imgArrow5} />
              </div>
            </div>
          </div>
        </a>
        <div className="s2 s3 s4 s150 s151" />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="857:4682" data-name="navigationbar">
        <a className="s16 s141 s17 s110 s26 s0 s28" data-node-id="857:4683">
          <div className="s111 s0 s28 s112" data-node-id="857:4684" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="857:4689">
            DING AI LAB
          </p>
        </a>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="857:4690">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="857:4691">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="857:4692">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="857:4693">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="857:4694">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="857:4695">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="857:4696">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="857:4697">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="857:4698">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="857:4699">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
      <div className="s106 s259 s2 s126 s260 s261" data-node-id="1035:573" data-name="DING_GOODS 1">
        <img alt="" className="s2 s3 s9 s262 s4 s1" src={imgDingGoods1} />
      </div>
    </div>
  );
}